import React, { useState, useEffect } from "react";
import { useFormikContext } from "formik";
import {
  Card,
  ChoiceList,
  TextField,
  Button,
  FormLayout,
} from "@shopify/polaris";
import capitalize from "lodash/capitalize";

export default function CustomerRoles() {
  const { values, setFieldValue } = useFormikContext();
  const [newRole, setNewRole] = useState("");
  const [roles, setRoles] = useState([]);

  const defaultRoles = [
    {
      label: "Customer",
      value: "customer",
      helpText: "Default WooCommerce customer accounts",
    },
    {
      label: "Vendor",
      value: "vendor",
    },
    {
      label: "Seller",
      value: "seller",
    },
  ];

  useEffect(() => {
    const customRoles = values.idRequiredCustomerRoles
      .filter((role) => !defaultRoles.some((r) => r.value === role))
      .map((role) => ({
        label: capitalize(role),
        value: role,
        helpText: `Custom role (${role})`,
      }));

    setRoles([...defaultRoles, ...customRoles]);
  }, [values.idRequiredCustomerRoles]);

  return (
    <Card.Section title="Customer Roles">
      <p className="ri-my-4 ri-gray-600">
        Require ID verification for any new accounts with the following roles.
      </p>
      <div className="ri-mb-4">
        <ChoiceList
          allowMultiple
          titleDisabled
          selected={values.idRequiredCustomerRoles || []}
          onChange={(v) => setFieldValue("idRequiredCustomerRoles", v)}
          choices={roles}
        />
      </div>

      <TextField
        helpText="Not seeing a role that requires verification? Add it here."
        label="Add role"
        value={newRole}
        onChange={(v) => setNewRole(v)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            setNewRole("");
          }
        }}
        connectedRight={
          <Button
            onClick={() => {
              if (!newRole) {
                return;
              }
              setNewRole("");
              setFieldValue("idRequiredCustomerRoles", [
                ...values.idRequiredCustomerRoles,
                newRole,
              ]);
            }}
          >
            Add role
          </Button>
        }
      />
    </Card.Section>
  );
}
